import intl from "react-intl-universal";

import deJsonUrl from '../locales/de-DE.json?url';
import enJsonUrl from '../locales/en-US.json?url';
import esJsonUrl from '../locales/es-ES.json?url';
import frJsonUrl from '../locales/fr-FR.json?url';
import hiJsonUrl from '../locales/hi-IN.json?url';
import hyJsonUrl from '../locales/hy-AM.json?url';
import jaJsonUrl from '../locales/ja-JP.json?url';
import koJsonUrl from '../locales/ko-KR.json?url';
import ruJsonUrl from '../locales/ru-RU.json?url';
import ukJsonUrl from '../locales/uk-UA.json?url';
import zhJsonUrl from '../locales/zh-CN.json?url';

const cachedLocales: any = {};

export async function updateLocale(newLocale: string) {
    // @ts-ignore
    if (cachedLocales[newLocale] === undefined) {
        // @ts-ignore
        switch (newLocale) {
            case 'de-DE':
                cachedLocales[newLocale] = await getLocale(deJsonUrl);
                break;
            case 'en-US':
                cachedLocales[newLocale] = await getLocale(enJsonUrl);
                break;
            case 'es-ES':
                cachedLocales[newLocale] = await getLocale(esJsonUrl);
                break;
            case 'fr-FR':
                cachedLocales[newLocale] = await getLocale(frJsonUrl);
                break;
            case 'hi-IN':
                cachedLocales[newLocale] = await getLocale(hiJsonUrl);
                break;
            case 'hy-AM':
                cachedLocales[newLocale] = await getLocale(hyJsonUrl);
                break;
            case 'ja-JP':
                cachedLocales[newLocale] = await getLocale(jaJsonUrl);
                break;
            case 'ko-KR':
                cachedLocales[newLocale] = await getLocale(koJsonUrl);
                break;
            case 'ru-RU':
                cachedLocales[newLocale] = await getLocale(ruJsonUrl);
                break;
            case 'uk-UA':
                cachedLocales[newLocale] = await getLocale(ukJsonUrl);
                break;
            case 'zh-CN':
                cachedLocales[newLocale] = await getLocale(zhJsonUrl);
                break;

        }
    }

    await intl.init({
        currentLocale: newLocale,
        locales: cachedLocales,
        escapeHtml: false,
        commonLocaleDataUrls: {
            en: "https://g.alicdn.com/react-intl-universal/locale-data/1.0.0/en.js",
            ru: "https://g.alicdn.com/react-intl-universal/locale-data/1.0.0/ru.js",
        }
    })
}

const getLocale = async (localeHref: string) => {
    const response = await fetch(localeHref);
    return await response.json();
}